import { Injectable } from '@angular/core';
import { IAlertsConfig } from '../app/ui-components/alerts/IAlertsConfig';

@Injectable()
export class AlertsConfig implements IAlertsConfig {
  readonly successTimeout = 3000;
  readonly failureTimeout = 5000;
}
